import ConfirmationModal from './confirmationModal';

namespace('IO.Views.Components', function (exports) {
  var ConfirmationDialog = ConfirmationModal.extend({
    initialize: function (options) {
      this.callbacks = [];
      this.options = {
        modal: {
          wait: true,
        },
        method: 'POST',
        proceedIfDataIsEmpty: false,
      };
      this.options = _.extend(
        this.options,
        typeof options === 'undefined' ? {} : options,
      );

      if (this.options.jst_template) {
        this.jstTemplate = this.options.jst_template;
      }

      if (this.options.template) {
        this.template = this.options.template;
      }

      this.extendableInitialize(this.options.modal);
    },

    impact: function (request_data) {
      var self = this;
      $.ajax({
        type: this.options.method,
        data: request_data,
        url: this.options.url,
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
        },
      }).done(function (data) {
        if (self.options.proceedIfDataIsEmpty && self._isEmpty(data)) {
          self._triggerCallbacks(true);
          return;
        }
        if (self.options.template) {
          self._setupRender(data, true);
        } else {
          self._setupRender(data);
        }
      });
      return self;
    },

    _setupData: function (data) {
      if (typeof this.options.transformData === 'function') {
        return this.options.transformData(data);
      }
      return data;
    },

    _isEmpty: function (data) {
      return typeof this.options.emptyCheck !== 'undefined'
        ? this.options.emptyCheck(data)
        : $.isEmptyObject(data);
    },

    _formatModal: function (data) {
      var onePercent = $(window).width() / 100,
        top = data.length === 0 ? 180 : 40,
        height = onePercent * 30,
        width = onePercent * (data.length === 0 ? 30 : 80);

      if (this.options.modalWidth !== undefined) {
        width = this.options.modalWidth;
      }

      if (this.options.modalHeight !== undefined) {
        height = this.options.modalHeight;
      }

      if (this.options.top !== undefined) {
        top = this.options.top;
      }

      return {
        top: top,
        left: ($(window).width() - width) / 2,
        width: width,
        height: height,
        fixedWidth: this.options.modalWidth !== undefined,
        fixedHeight: this.options.modalHeight !== undefined,
      };
    },

    _getTemplate: function (data, style) {
      return this.renderTemplate({
        data: data,
        width: style.width,
        height: style.height,
      });
    },
  });

  exports.ConfirmationDialog = ConfirmationDialog;
});
